import moment from "moment";
import React from "react";
import {
	TORB3BackendRecord,
	TORB3Record,
} from "../../../../../redux/app/orb3/@types";
import { TORB3GroupA5 } from "../../../../../redux/app/orb3/groups/group-a";
import ORB3TableRows, { renderDataTable } from "../ORB3TableRows";

const ODS_COLUMNS = [
	{ key: "substanceType", label: "Substance Type" },
	{ key: "quantityKg", label: "Qty (kgs)" },
];

type OwnProps = {
	orb3Record: TORB3Record | TORB3BackendRecord;
	theme?: "light" | "dark";
};
type ORB3GroupA5PreviewProps = OwnProps;

function ORB3GroupA5Preview(props: ORB3GroupA5PreviewProps) {
	const record = props.orb3Record as TORB3GroupA5;
	const operationDate = moment(record.selectedDate, "YYYY-MM-DD").format(
		"DD-MMM-YYYY",
	);
	const { itemA5 } = record;

	function renderItemP1() {
		const startDTLocal = `${itemA5.startDate}T${itemA5.startTime}:00${record.timeZone}`;
		const utcStart = moment.utc(startDTLocal);
		const stopDTLocal = `${itemA5.stopDate}T${itemA5.stopTime}:00${record.timeZone}`;
		const utcStop = moment.utc(stopDTLocal);
		return (
			<>
				<h4 className="font-medium uppercase">
					Start: {utcStart.format("HH:mm")} hrs UTC on{" "}
					{utcStart.format("DD-MMM-YYYY")} ({itemA5.startTime} SMT on{" "}
					{moment(itemA5.startDate, "YYYY-MM-DD").format("DD-MMM-YYYY")})
				</h4>
				<h4 className="font-medium uppercase">
					Stop: {utcStop.format("HH:mm")} hrs UTC on{" "}
					{utcStop.format("DD-MMM-YYYY")} ({itemA5.stopTime} SMT on{" "}
					{moment(itemA5.stopDate, "YYYY-MM-DD").format("DD-MMM-YYYY")})
				</h4>
			</>
		);
	}

	function renderMain() {
		return (
			<ORB3TableRows
				record={record}
				tableRows={[
					[operationDate, "3-A", "1.5", renderItemP1()],
					[
						null,
						null,
						"-",
						itemA5.vesselPositionType === "PORT"
							? `Port: ${itemA5.portName}`
							: `Position: ${itemA5.latitude} / ${itemA5.longitude}`,
					],
					[null, null, "-", renderDataTable(itemA5.items, ODS_COLUMNS)],
					[null, null, "NOTE", record.remarks],
				]}
				theme={props.theme}
			/>
		);
	}

	return renderMain();
}

export default ORB3GroupA5Preview;
